module.exports = __webpack_public_path__ + "img/icon-ai-dark-blue2.341f462a.svg";